export const SHOW_TOOLS_HIDE_AFTER_MS = 5000;
//# sourceMappingURL=constants.preenvesnextjs.map
